// extracted by mini-css-extract-plugin
module.exports = {"SimulationDetail":"SimulationDetail_SimulationDetail__viF-4","divider":"SimulationDetail_divider__1Zy0_","LimitsLabel":"SimulationDetail_LimitsLabel__3hE9S"};